// @flow
/* eslint-disable */

import { all, call, put, takeLatest, select } from 'redux-saga/effects';
// import get from 'lodash/get';
import { getLabel } from '@fil-global/eiswurfel';
import { axiosClientAmaznS3, axiosClient } from '../config/axios-clientFilView';
import { LOGOUT,SESSIONLOGOUT } from '../containers/organisms/Header/constants';
import { logoutSaga,handleSessionLogoutSaga } from '../containers/organisms/Header/Header.saga';
import { VERIFY_EMAIL } from '../containers/templates/EmailVerification/EmailVerification.constants';
import { verfiyEmail } from '../containers/templates/EmailVerification/EmailVerification.saga';
import {
  FETCH_LABEL,
  FETCH_LABEL_FAILURE,
  FETCH_LABEL_SUCCESS,
} from './constants';

export function* fetchLabels() {
  try {
    const store = yield select();
    const role =
      sessionStorage.getItem('role') === null ? '' : sessionStorage.getItem('role');
    const language = store.global.globalData.language;
    const schemeType = sessionStorage.getItem('schemeType');
    if (role !== undefined && role !== '' && schemeType !== null) {
      const fundClassification = schemeType === 'ICRS' || schemeType === 'F'
          ? sessionStorage.getItem('fundClassification')
          : sessionStorage.getItem('schemeSubType') === 'null'
            ? ''
            : sessionStorage.getItem('schemeSubType');
      let menuUrl = `navigation/role?roleId=${role}&schemeType=${schemeType}&fundClassification=${fundClassification}&locale=${language}`;
      let labelsUrl = `json-labels/pageData_${language}.json`;
      const { data } = yield call(axiosClient.get, menuUrl);
      const page = yield call(axiosClientAmaznS3.get, labelsUrl);
      data.navData.nav.loginWayFinder = page.data.loginWayFinder;
      Object.assign(data.navData, page.data);
      yield put({ type: FETCH_LABEL_SUCCESS, labels: data.navData });
    } else {
      const { data } = yield call(
        axiosClientAmaznS3.get,
        `json-labels/loginNavData_${language}.json`,
      );
      yield put({ type: FETCH_LABEL_SUCCESS, labels: data });
    }
  } catch (err) {
    yield put({ type: FETCH_LABEL_FAILURE });
  }
}

export function getErrorMsg(errorCode, login) {
  switch (errorCode) {
    case 'A':
      return getLabel(login, 'userNotExist');
    case 'FV0455707':
      return getLabel(login, 'invalidCredentials');
    case 'FV0455700':
      return getLabel(login, 'authTokenExpired');
    case 'FV0455705':
      return getLabel(login, 'credentialsNotActive');
    case 'I':
      return getLabel(login, 'userInactive');
    case 'FV06000113':
      return getLabel(login, 'emalNotVerified');
    case 'FV0455702':
      return getLabel(login, 'challengeExpired');
    case 'FV0455704':
      return getLabel(login, 'credentialExpired');
    case 'FV0455705':
      return getLabel(login, 'credentialsNotActive');
    case 'FV0450004':
      return getLabel(login, 'cpsDecommisioned');
    default:
      return getLabel(login, 'internalServerError');
  }
}

export function getB64EncodedUserNameForArcotId(userName) {
  return btoa(userName.toLowerCase());
}

export default function* globalSaga() {
  yield all([
    takeLatest(FETCH_LABEL, fetchLabels),
    takeLatest(LOGOUT, logoutSaga),
    takeLatest(SESSIONLOGOUT, handleSessionLogoutSaga),
    takeLatest(VERIFY_EMAIL, verfiyEmail),
  ]);
}

